import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './CheckBox.module.scss'

const CheckBox = ({ id, label, isSelected, onClick, classNames: customClassNames }) => (
  <label htmlFor={id} className={classNames(classes.wrapper, customClassNames?.wrapper)}>
    <input
      id={id}
      type='checkbox'
      className={classes.hiddenInput}
      checked={isSelected}
      onChange={onClick}
    />
    <span
      className={classNames(
        classes.checkbox,
        { [classes.checked]: isSelected },
        customClassNames?.checkbox
      )}
    >
      {isSelected && <i className='fa fa-check' aria-hidden='true' />}
    </span>
    <span className={classNames(classes.label, customClassNames?.label)}>{label}</span>
  </label>
)

CheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  classNames: PropTypes.shape({
    wrapper: PropTypes.string,
    checkbox: PropTypes.string,
    label: PropTypes.string,
  }),
}

export default CheckBox
